import axios from "../utils/axios";

export const getPlants = () => {
    return axios.get(`/Plant/GetList`);
};

export const getMaintenanceType = () => {
    return axios.get(`/MaintenanceType/GetDetailedList`);
};

export const getMailGroup = () => {
    return axios.get(`/MailGroup/GetList`);
};

export const getMailGroupPeriod = () => {
    return axios.get(`/MailGroup/GetPeriodList`);
};

export const updateMaintenanceType = (payload) => {
    return axios.post(`/MaintenanceType/Update`, payload);
};

export const addMaintenanceType = (payload) => {
    return axios.post(`/MaintenanceType/Add`, payload);
};

export const deleteMaintenanceType = (payload) => {
    return axios.post(`/MaintenanceType/Delete`, payload);
};
